(function () {
  'use strict';

  var ATTRIBUTION_KEY = 'pyc.marketing_attribution.v1';
  var LEAD_KEY = 'pyc.openai_lead.v1';
  var MAX_ATTRIBUTION_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  var PARAM_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'utm_id', 'campaign_id', 'adgroup_id', 'ad_id', 'oppref', 'openai_ref',
    'gclid', 'msclkid'
  ];

  function safeParse(value) {
    try { return JSON.parse(value || 'null'); } catch (e) { return null; }
  }

  function load(key) {
    var value = null;
    try { value = safeParse(window.sessionStorage.getItem(key)); } catch (e) {}
    if (!value) {
      try { value = safeParse(window.localStorage.getItem(key)); } catch (e2) {}
    }
    return value;
  }

  function save(key, value) {
    var encoded = JSON.stringify(value);
    try { window.sessionStorage.setItem(key, encoded); } catch (e) {}
    try { window.localStorage.setItem(key, encoded); } catch (e2) {}
  }

  function capture() {
    var params = new URLSearchParams(window.location.search);
    var captured = {};
    PARAM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        captured[key] = value.slice(0, 512);
      }
    });
    if (Object.keys(captured).length) {
      var current = {
        params: captured,
        captured_at: Date.now(),
        landing_url: window.location.href
      };
      save(ATTRIBUTION_KEY, current);
      return current;
    }
    return load(ATTRIBUTION_KEY) || { params: {} };
  }

  function getAttribution() {
    var state = load(ATTRIBUTION_KEY);
    if (!state || !state.params || !state.captured_at) return { params: {} };
    if (Date.now() - state.captured_at > MAX_ATTRIBUTION_AGE_MS) return { params: {} };
    return state;
  }

  function decorateUrl(value) {
    var url;
    try { url = new URL(value, window.location.origin); } catch (e) { return value; }
    if (url.origin !== window.location.origin) return value;
    var params = getAttribution().params || {};
    PARAM_KEYS.forEach(function (key) {
      if (params[key] && !url.searchParams.has(key)) url.searchParams.set(key, params[key]);
    });
    return url.pathname + (url.search ? url.search : '') + (url.hash ? url.hash : '');
  }

  function decorateLeadLinks(root) {
    (root || document).querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var url;
      try { url = new URL(href, window.location.origin); } catch (e) { return; }
      if (url.origin !== window.location.origin || url.pathname !== '/pages/register-store') return;
      link.setAttribute('href', decorateUrl(href));
    });
  }

  function normalizeIdentity(value, stripPunctuation) {
    var normalized = String(value || '').trim().toLowerCase();
    if (stripPunctuation) normalized = normalized.replace(/[\s\x21-\x2f\x3a-\x40\x5b-\x60\x7b-\x7e]/g, '');
    return normalized;
  }

  function sha256(value) {
    if (!value || !window.crypto || !window.crypto.subtle || !window.TextEncoder) return Promise.resolve(null);
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)).then(function (buffer) {
      return Array.prototype.map.call(new Uint8Array(buffer), function (byte) {
        return byte.toString(16).padStart(2, '0');
      }).join('');
    }).catch(function () { return null; });
  }

  function newEventId() {
    var suffix = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
    return 'pyc_lead_' + suffix;
  }

  function prepareLead(identity) {
    var state = {
      event_id: newEventId(),
      timestamp_ms: Date.now(),
      attribution: getAttribution().params || {}
    };
    save(LEAD_KEY, state);
    var ready = Promise.all([
      sha256(normalizeIdentity(identity && identity.email, false)),
      sha256(normalizeIdentity(identity && identity.firstName, true)),
      sha256(normalizeIdentity(identity && identity.lastName, true))
    ]).then(function (hashes) {
      if (hashes[0]) state.email_sha256 = hashes[0];
      if (hashes[1]) state.first_name_sha256 = hashes[1];
      if (hashes[2]) state.last_name_sha256 = hashes[2];
      save(LEAD_KEY, state);
      return state;
    });
    return { eventId: state.event_id, ready: ready };
  }

  function leadRedirect(value, eventId) {
    var decorated = decorateUrl(value);
    var url = new URL(decorated, window.location.origin);
    url.searchParams.set('pyc_event_id', eventId);
    return url.pathname + url.search + url.hash;
  }

  function emitOpenAiLead(config) {
    var state = load(LEAD_KEY) || {};
    var eventId = new URLSearchParams(window.location.search).get('pyc_event_id') || state.event_id;
    var attribution = state.attribution || getAttribution().params || {};
    var oppref = attribution.oppref || attribution.openai_ref;
    if (!eventId || !config || !config.pixelId) return Promise.resolve({ skipped: true });

    if (typeof window.oaiq === 'function') {
      window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: eventId });
    }
    if (!config.conversionEndpoint) return Promise.resolve({ pixel: true, server: false });

    var body = {
      event_id: eventId,
      timestamp_ms: state.timestamp_ms || Date.now(),
      source_url: new URL(decorateUrl(window.location.href), window.location.origin).toString()
    };
    if (oppref) body.oppref = oppref;
    ['email_sha256', 'first_name_sha256', 'last_name_sha256'].forEach(function (key) {
      if (state[key]) body[key] = state[key];
    });
    return fetch(config.conversionEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (response) {
      return { pixel: true, server: response.ok, status: response.status };
    }).catch(function () { return { pixel: true, server: false }; });
  }

  capture();
  window.PYCMarketingAttribution = {
    get: getAttribution,
    decorateUrl: decorateUrl,
    decorateLeadLinks: decorateLeadLinks,
    prepareLead: prepareLead,
    leadRedirect: leadRedirect,
    emitOpenAiLead: emitOpenAiLead
  };

  function boot() { decorateLeadLinks(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
